// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"table-row_tableRow__MQ2em"};